// extracted by mini-css-extract-plugin
export var tabs = "style-module--tabs--621af";